export default class Widget {
  constructor(obj) {
    // eslint-disable-next-line no-unused-expressions
    obj && Object.assign(this, obj);
  }
}
